var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractAuthenticatedService from '../abstract-authenticated-service';
import DeleteProjectTask from '../../../model/task/organisation/delete-project-task';
import GetProjectSettingsTask from '../../../model/task/organisation/get-project-settings-task';
import GetProjectTask from '../../../model/task/organisation/get-project-task';
import GetProjectsTask from '../../../model/task/organisation/get-projects-task';
import PatchProjectTask from '../../../model/task/organisation/patch-project-task';
import PostProjectTask from '../../../model/task/organisation/post-project-task';
import PutProjectSettingsTask from '../../../model/task/organisation/put-project-settings-task';
export default class ProjectService extends AbstractAuthenticatedService {
    /**
     * Returns matching projects
     *
     * @returns
     */
    findProjects(searchConditions) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetProjectsTask();
            task.token = this.token;
            task.searchConditions = searchConditions;
            return this.runTask(task);
        });
    }
    /**
     * Loads a project
     *
     * @param id
     * @returns
     */
    loadProject(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetProjectTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Creates a project
     *
     * @param project
     * @returns
     */
    createProject(project) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PostProjectTask();
            task.token = this.token;
            task.project = project;
            return this.runTask(task);
        });
    }
    /**
     * Updates a project
     *
     * @param project
     * @returns
     */
    updateProject(project) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PatchProjectTask();
            task.token = this.token;
            task.project = project;
            return this.runTask(task);
        });
    }
    /**
     * Deletes a project
     *
     * @param id
     * @returns
     */
    deleteProject(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new DeleteProjectTask();
            task.token = this.token;
            task.id = id;
            return this.runTask(task);
        });
    }
    /**
     * Loads project settings
     *
     * @param projectId
     * @returns
     */
    loadProjectSettings(projectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new GetProjectSettingsTask();
            task.token = this.token;
            task.projectId = projectId;
            return this.runTask(task);
        });
    }
    /**
     * Saves project settings
     *
     * @param projectId
     * @param settings
     * @returns
     */
    saveProjectSettings(projectId, settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const task = new PutProjectSettingsTask();
            task.token = this.token;
            task.projectId = projectId;
            task.settings = settings;
            return this.runTask(task);
        });
    }
}
//# sourceMappingURL=project-service.js.map